// extracted by mini-css-extract-plugin
export default {"root":"NavBar_root__xk5Jq","button":"NavBar_button__2as3X","notice":"NavBar_notice__9znSt"};